import { Link } from 'react-router';
import { COOKIE_SETTINGS_EVENT } from '../privacy/cookie-consent';

export function Footer() {
  return (
    <footer className="bg-surface-900 text-surface-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="/logo-horizontal-white.svg" 
                alt="Fixtyer - UK Pothole Damage Claims" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-sm text-surface-400 max-w-md">
              Fixtyer is a self-service document preparation platform that provides documents, 
              guidance, and information to help you prepare and submit your own pothole damage 
              claim. Mac doesn't provide legal advice or act on your behalf, but will guide 
              you through the process, every step of the way.
            </p>
            <p className="text-sm text-surface-400 max-w-md mt-3">
              Registered with the Information Commissioner's Office (ICO) for data protection purposes.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="font-display font-semibold text-white mb-4">Product</p>
            <ul className="space-y-2">
              <li>
                <Link to="/how-it-works" className="text-sm text-surface-400 hover:text-white transition-colors">
                  How it works
                </Link>
              </li>
              <li>
                <Link to="/meet-mac" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Meet Mac
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-surface-400 hover:text-white transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/guides" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Guides
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-surface-400 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/councils" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Council Reports
                </Link>
              </li>
              <li>
                <Link to="/data/council-road-maintenance-ratings" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Council Ratings Dataset
                </Link>
              </li>
              <li>
                <Link to="/pothole-hall-of-shame" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Pothole Hall of Shame
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-display font-semibold text-white mb-4">Legal</p>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT))}
                  className="text-sm text-surface-400 hover:text-white transition-colors"
                >
                  Cookie Settings
                </button>
              </li>
              <li>
                <Link to="/media-enquiries" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Media Enquiries
                </Link>
              </li>
              <li>
                <Link to="/press" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Press Releases
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-sm text-surface-400 hover:text-white transition-colors">
                  Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-surface-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <p className="text-sm text-surface-500">
              © {new Date().getFullYear()} Elevyn Technology Group Limited. All rights reserved.
            </p>
            <p className="text-sm text-surface-500">
              Cradley Enterprise Centre, Maypole Fields, Halesowen, B63 2QB
            </p>
          </div>
          <p className="text-xs text-surface-500 mt-4">
            Website designed and maintained by{' '}
            <a
              href="https://stourbridgewebstudio.co.uk/work/fixtyer"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Stourbridge Web Studio
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
